exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js??postcss!@angular/material/prebuilt-themes/deeppurple-amber.css"), "");

// module
exports.push([module.id, ".set-map {\r\n  height: 900px;\r\n  width: 100%!important;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/dashboard/dashboard.component.css
// module id = ../../../../../src/app/components/dashboard/dashboard.component.css
// module chunks = main